<template>
  <component :is="iconComponent"></component>
</template>

<script setup>
import IconWeight from './IconWeight';
import IconTerrain from './IconTerrain';
import IconArchSupport from './IconArchSupport';
import IconArchType from './IconArchType';
import IconDrop from './IconDrop';
import IconUse from './IconUse';
import IconSize from './IconSize';
import IconWidth from './IconWidth';
import IconTop from './IconTop';
import IconColorways from './IconColorways';
import IconCollection from './IconCollection';
import IconTraction from './IconTraction';
import IconStyle from './IconStyle';
import IconInspiredFrom from './IconInspiredFrom';
import IconPronation from './IconPronation';
import IconClosure from './IconClosure';
import IconFit from './IconFit';
import IconFeatures from './IconFeatures';
import IconBrand from './IconBrand';
import IconMaterial from './IconMaterial';
import IconSKU from './IconSKU';
import IconTechnology from './IconTechnology';
import IconUpdate from './IconUpdate';
import IconHeelHeight from './IconHeelHeight';
import IconReleaseDate from './IconReleaseDate';
import IconLaceType from './IconLaceType';
import IconBreathability from './IconBreathability';
import IconComfort from './IconComfort';
import IconDistance from './IconDistance';
import IconCushioning from './IconCushioning';
import IconDurability from './IconDurability';
import IconFlexibility from './IconFlexibility';
import IconFootCondition from './IconFootCondition';
import IconForefootHeight from './IconForefootHeight';

import IconBaseModel from './IconBaseModel';
import IconCleatDesign from './IconCleatDesign';
import IconCollaboration from './IconCollaboration';
import IconConstruction from './IconConstruction';
import IconCramponCompatibility from './IconCramponCompatibility';
import IconCut from './IconCut';
import IconDesignedBy from './IconDesignedBy';
import IconDownturn from './IconDownturn';
import IconEmbelishment from './IconEmbelishment';
import IconEnvironment from './IconEnvironment';
import IconEvent from './IconEvent';
import IconGroundFeel from './IconGroundFeel';
import IconImpactProtection from './IconImpactProtection';
import IconLacingSystem from './IconLacingSystem';
import IconLastShape from './IconLastShape';
import IconLevel from './IconLevel';
import IconLightweight from './IconLightweight';
import IconLining from './IconLining';
import IconLockdown from './IconLockdown';
import IconMidsole from './IconMidsole';
import IconOrigin from './IconOrigin';
import IconOrthoticFriendly from './IconOrthoticFriendly';
import IconOutsole from './IconOutsole';
import IconOutsoleDurability from './IconOutsoleDurability';
import IconPrint from './IconPrint';
import IconRigidity from './IconRigidity';
import IconShoeType from './IconShoeType';
import IconSignature from './IconSignature';
import IconSpikeSize from './IconSpikeSize';
import IconSpikeType from './IconSpikeType';
import IconStability from './IconStability';
import IconStickiness from './IconStickiness';
import IconStretch from './IconStretch';
import IconStudType from './IconStudType';
import IconSupport from './IconSupport';
import IconSurface from './IconSurface';
import IconThickness from './IconThickness';
import IconToeProtection from './IconToeProtection';
import IconToebox from './IconToebox';
import IconWaterproofing from './IconWaterproofing';
import IconWornBy from './IconWornBy';
import IconSeason from './IconSeason';
import IconStrikePattern from './IconStrikePattern';
import IconCondition from './IconCondition';

import IconType from './IconType';
import IconSpecialEditions from './IconSpecialEditions';

const icons = {
  size: markRaw(IconSize),
  weight: markRaw(IconWeight),
  terrain: markRaw(IconTerrain),
  'arch-support': markRaw(IconArchSupport),
  'heel-to-toe-drop': markRaw(IconDrop),
  use: markRaw(IconUse),
  width: markRaw(IconWidth),
  top: markRaw(IconTop),
  colorways: markRaw(IconColorways),
  collection: markRaw(IconCollection),
  traction: markRaw(IconTraction),
  style: markRaw(IconStyle),
  'inspired-from': markRaw(IconInspiredFrom),
  pronation: markRaw(IconPronation),
  closure: markRaw(IconClosure),
  fit: markRaw(IconFit),
  features: markRaw(IconFeatures),
  brand: markRaw(IconBrand),
  material: markRaw(IconMaterial),
  skus: markRaw(IconSKU),
  technology: markRaw(IconTechnology),
  update: markRaw(IconUpdate),
  'heel-height': markRaw(IconHeelHeight),
  'release-date': markRaw(IconReleaseDate),
  'lace-type': markRaw(IconLaceType),
  breathability: markRaw(IconBreathability),
  comfort: markRaw(IconComfort),
  distance: markRaw(IconDistance),
  cushioning: markRaw(IconCushioning),
  durability: markRaw(IconDurability),
  flexibility: markRaw(IconFlexibility),
  'foot-condition': markRaw(IconFootCondition),
  'forefoot-height': markRaw(IconForefootHeight),
  'base-model': markRaw(IconBaseModel),
  'cleat-design': markRaw(IconCleatDesign),
  collaboration: markRaw(IconCollaboration),
  construction: markRaw(IconConstruction),
  'crampon-compatibility': markRaw(IconCramponCompatibility),
  cut: markRaw(IconCut),
  'designed-by': markRaw(IconDesignedBy),
  downturn: markRaw(IconDownturn),
  embelishment: markRaw(IconEmbelishment),
  environment: markRaw(IconEnvironment),
  event: markRaw(IconEvent),
  'ground-feel': markRaw(IconGroundFeel),
  'impact-protection': markRaw(IconImpactProtection),
  'lacing-system': markRaw(IconLacingSystem),
  'last-shape': markRaw(IconLastShape),
  lining: markRaw(IconLining),
  lockdown: markRaw(IconLockdown),
  midsole: markRaw(IconMidsole),
  origin: markRaw(IconOrigin),
  'orthotic-friendly': markRaw(IconOrthoticFriendly),
  outsole: markRaw(IconOutsole),
  'outsole-durability': markRaw(IconOutsoleDurability),
  print: markRaw(IconPrint),
  rigidity: markRaw(IconRigidity),
  'shoe-type': markRaw(IconShoeType),
  signature: markRaw(IconSignature),
  'spike-size': markRaw(IconSpikeSize),
  'spike-type': markRaw(IconSpikeType),
  stability: markRaw(IconStability),
  stickiness: markRaw(IconStickiness),
  stretch: markRaw(IconStretch),
  'stud-type': markRaw(IconStudType),
  support: markRaw(IconSupport),
  surface: markRaw(IconSurface),
  thickness: markRaw(IconThickness),
  'toe-protection': markRaw(IconToeProtection),
  toebox: markRaw(IconToebox),
  waterproofing: markRaw(IconWaterproofing),
  'worn-by': markRaw(IconWornBy),
  season: markRaw(IconSeason),
  'strike-pattern': markRaw(IconStrikePattern),
  level: markRaw(IconLevel),
  lightweight: markRaw(IconLightweight),
  type: markRaw(IconType),
  'special-editions': markRaw(IconSpecialEditions),
  condition: markRaw(IconCondition),
  'arch-type': markRaw(IconArchType),
}

const props = defineProps({
  slug: String,
})

const iconComponent = computed(() => icons[props.slug] || icons['collection']);
</script>